import { Inject } from "@angular/core";
import { ContentControlledEditingDirective } from '../editing-directive';
import { ContentControlledKeyframe } from '../keyframe';
import ContentControlStudioOperation from "./content-control-studio-operation";

export default class ContentControlStudioUpdateKeyframeToEventOperation extends ContentControlStudioOperation {
  constructor(
    public event: ContentControlledEditingDirective,
    public currentKeyframe: ContentControlledKeyframe,
    public newKeyframe: ContentControlledKeyframe,
    callback?,
  ) {
    super(
      () => {
        if (event) {
          event.keyframes
            .find((x) => x.sameTime(newKeyframe))
            .ingest(newKeyframe);
        }
      },
      () => {
        if (event) {
          event.keyframes
            .find((x) => x.sameTime(currentKeyframe))
            .ingest(currentKeyframe);
        }
      },
      callback,
    );
  }
}
